import React from 'react';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import { dateFormatter, infoFormatterIntl, localeFormatter } from '../../../../utils/formatters';
import { PROCEDURE_TYPE } from '../../../../configs';

export default function CarView(prop) {
  const {
    data, procedure, prefix = '', fieldsValidation,
  } = prop;
  const {
    vehicle_brand,
    vehicle_model,
    vehicle_year,
    vehicle_color,
    vehicle_lpn,
    vehicle_vin,
    vehicle_registration_number,
    vehicle_registration_issue_date,
    ecology_class,
    has_special_lifting_device,
    tech_control_address,
    ownership_type,
    ownership_contract_number,
    ownership_contract_effective_date,
    ownership_contract_expiration_date,
  } = data;
  return (
    <>
      {procedure !== PROCEDURE_TYPE.PROCEDURE_kt_exlt ? (
        <Row className="row-cols-3">
          {infoFormatterIntl('vehicle_brand', vehicle_brand, fieldsValidation, `${prefix}vehicle_brand`)}
          {infoFormatterIntl('vehicle_model', vehicle_model, fieldsValidation, `${prefix}vehicle_model`)}
          {infoFormatterIntl('vehicle_year', vehicle_year, fieldsValidation, `${prefix}vehicle_year`)}
        </Row>
      ) : (
        <Row className="row-cols-2">
          {infoFormatterIntl('vehicle_brand', vehicle_brand, fieldsValidation, `${prefix}vehicle_brand`)}
          {infoFormatterIntl('vehicle_model', vehicle_model, fieldsValidation, `${prefix}vehicle_model`)}
        </Row>
      )}
      <Row className="row-cols-3">
        {infoFormatterIntl('vehicle_color', vehicle_color, fieldsValidation, `${prefix}vehicle_color`)}
        {infoFormatterIntl('vehicle_lpn', vehicle_lpn, fieldsValidation, `${prefix}vehicle_lpn`)}
        {infoFormatterIntl('vehicle_vin', vehicle_vin, fieldsValidation, `${prefix}vehicle_vin`)}
      </Row>

      {procedure !== PROCEDURE_TYPE.PROCEDURE_kt_exlt
        ? (
          <Row className="row-cols-3">
            {infoFormatterIntl('vehicle_registration_number', vehicle_registration_number, fieldsValidation, `${prefix}vehicle_registration_number`)}
            {infoFormatterIntl('vehicle_registration_issue_date', dateFormatter(vehicle_registration_issue_date), fieldsValidation, `${prefix}vehicle_registration_issue_date`)}
            {procedure !== PROCEDURE_TYPE.PROCEDURE_1227_8 ? infoFormatterIntl('ecology_class', localeFormatter('ecology-class', ecology_class), fieldsValidation, `${prefix}ecology_class`) : null}
          </Row>
        ) : null }

      {procedure !== PROCEDURE_TYPE.PROCEDURE_1227_8 && procedure !== PROCEDURE_TYPE.PROCEDURE_kt_exlt ? (
        <>
          <Row className="row-cols-1">
            {infoFormatterIntl('has_special_lifting_device', has_special_lifting_device ? 'Есть' : 'Нет', fieldsValidation, `${prefix}has_special_lifting_device`)}
          </Row>
          {procedure !== PROCEDURE_TYPE.PROCEDURE_1227_6 ? (
            <Row className="row-cols-1">
              {infoFormatterIntl('tech_control_address', tech_control_address, fieldsValidation, `${prefix}tech_control_address`)}
            </Row>
          ) : null }
        </>
      ) : null}

      {procedure !== PROCEDURE_TYPE.PROCEDURE_kt_exlt ? (
        <>
          <Row className="row-cols-2">
            {infoFormatterIntl('ownership_type', localeFormatter('ownership.type', ownership_type), fieldsValidation, `${prefix}ownership_type`)}
            {infoFormatterIntl('ownership_contract_number', ownership_contract_number, fieldsValidation, `${prefix}ownership_contract_number`)}
          </Row>
          <Row className="row-cols-2">
            {infoFormatterIntl('ownership_contract_effective_date', dateFormatter(ownership_contract_effective_date), fieldsValidation, `${prefix}ownership_contract_effective_date`)}
            {infoFormatterIntl('ownership_contract_expiration_date', dateFormatter(ownership_contract_expiration_date), fieldsValidation, `${prefix}ownership_contract_expiration_date`)}
          </Row>
        </>
      ) : null }

    </>
  );
}
